export default __webpack_public_path__ + "static/media/ba.46965929.svg";